import React from 'react';
import './style.css';
import defuse from './../../1.mp3';
import Scream from './../../scream05.wav';
import c2a5_hg_lebuz from './../../c2a5_hg_lebuz.wav';
import gr_pain5 from './../../gr_pain5.wav';
import $ from 'jquery';

const Help = `
    Available commands:
    help,
    clear,
    owner
`

const HelpCheatsON = `
    Available commands:
    help,
    clear,
    owner,
    defuse,
    scienceteam,
    esqueca,
    paramedico,
    spin
`


const Created = `
    Created by Kaway404, SNOOP
`

class Console extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        value: '',
        exec: [],
        svCheats: false,
        spin: false
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  playDefuse(){
    const audioEl = document.getElementsByClassName("defuse")[0]
    audioEl.play()
  }
  playScream(){
    const audioEl = document.getElementsByClassName("Scream")[0]
    audioEl.play()
  }
  playEsqueca(){
    const audioEl = document.getElementsByClassName("c2a5_hg_lebuz")[0]
    audioEl.play()
  }
  playPara(){
    const audioEl = document.getElementsByClassName("gr_pain5")[0]
    audioEl.play()
  }
  handleSubmit(event){
    event.preventDefault();
    if(this.state.value.trim().length > 0){
    let items = [...this.state.exec];
    if(this.state.value == "help"){
        if(!this.state.svCheats){
        items.push({
            "title": this.state.value,
            "desc": "All commands:",
            "data": Help
        })
        }  else{
            items.push({
                "title": this.state.value,
                "desc": "All commands:",
                "data": HelpCheatsON
            })
        }
    }
    else if(this.state.value == "defuse"){
        if(this.state.svCheats){
            this.playDefuse()
        } else{
            items.push({
                "title": this.state.value,
                "desc": "sv_cheats is not enabled.",
                "data": `sv_cheats in 0.`
            })
        }     
    }
    else if(this.state.value == "paramedico"){
        if(this.state.svCheats){
            this.playPara()
        } else{
            items.push({
                "title": this.state.value,
                "desc": "sv_cheats is not enabled.",
                "data": `sv_cheats in 0.`
            })
        }     
    } else if(this.state.value == "spin"){
        $("body").addClass("spin")
        setTimeout(() => {
            $("body").removeClass("spin")
        }, 1200);
    }
    else if(this.state.value == "esqueca"){
        if(this.state.svCheats){
            this.playEsqueca()
        } else{
            items.push({
                "title": this.state.value,
                "desc": "sv_cheats is not enabled.",
                "data": `sv_cheats in 0.`
            })
        }     
    }
    else if(this.state.value == "scienceteam"){
        if(this.state.svCheats){
            this.playScream()
        } else{
            items.push({
                "title": this.state.value,
                "desc": "sv_cheats is not enabled.",
                "data": `sv_cheats in 0.`
            })
        }  
    }
    else if(this.state.value == "sv_cheats 1"){
        items.push({
            "title": this.state.value,
            "desc": "All commands:",
            "data": `sv_cheats On`
        })
        this.setState({svCheats: true})
    } else if(this.state.value == "sv_cheats 0"){
        items.push({
            "title": this.state.value,
            "desc": "All commands:",
            "data": `sv_cheats Off`
        })
        this.setState({svCheats: false})
    }
    else if(this.state.value == "owner"){
        items.push({
            "title": this.state.value,
            "desc": "Who raised me?:",
            "data": Created
        })
    }
    else if(this.state.value == "clear"){
        items = []
    } else{
        items.push({
            "title": this.state.value,
            "desc": "Not found:",
            "data": `Command not found.`
        })
    }
    this.setState({exec: items});
    this.setState({value: ''})
    }
  }
  handleChange(event) {
    this.setState({value: event.target.value});
  }
  render(){
    return <div className={(this.state.spin ? 'spin' : 'start')}>
        <div className="console">
            <div className="command">
                { this.state.exec.map((item, index) => (
                    <div key={index}>
                    <span> {item.title} - {item.desc} <br/> {item.data}
                    </span>
                    </div>
                ))}
            </div>
            <div className="bottom">
            <form onSubmit={this.handleSubmit}>
                <input 
                value={this.state.value}
                onChange={this.handleChange}
                type="text" placeholder="Command"/>
            </form>
            </div>
        </div>
        <audio className="defuse">
          <source src={defuse}></source>
        </audio>
        <audio className="Scream">
          <source src={Scream}></source>
        </audio>
        <audio className="c2a5_hg_lebuz">
          <source src={c2a5_hg_lebuz}></source>
        </audio>
        <audio className="gr_pain5">
          <source src={gr_pain5}></source>
        </audio>
        
    </div>
  };
}

export default Console;